import { EMPTY_STRING } from '../../../../constants/common'
import { getPaginationApiParams } from '../../../../utils/pagination'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
} from '../../../Email'
import { REQUEST_ALL_ITEMS_PAGINATION } from '../../../Request'

export function getRequestDataByTaskParams(id) {
  return {
    ...getPaginationApiParams({ pageSize: REQUEST_ALL_ITEMS_PAGINATION }),
    filters: {
      pk: [id],
    },
  }
}

export function getThreadParams(data) {
  if (data.result?.request_thread_uuids) {
    return { append_request_threads: data.result?.request_thread_uuids }
  }

  const messages = data.data?.messages || data.results?.objects

  if (messages?.length > 0) {
    return { append_request_threads: messages.map(item => item.request_thread) }
  }

  return {}
}

export function getEmailCreationPopUpSourceId({ draftId, item }) {
  return `${draftId ?? EMPTY_STRING}:${item?.id ?? EMPTY_STRING}`
}

export function getEmailCreationPopUpFieldsProps({
  loadRecipientsInitialValue,
  recipientsFilterModalInitialValues,
  withServiceAccount,
}) {
  const recipientsFieldProps = recipientsFilterModalInitialValues
    ? { filterModalInitialValues: recipientsFilterModalInitialValues }
    : null

  return {
    ...(recipientsFieldProps
      ? {
          [EMAIL_CREATION_FORM_FIELD_NAME_BCC]: recipientsFieldProps,
          [EMAIL_CREATION_FORM_FIELD_NAME_CC]: recipientsFieldProps,
        }
      : null),
    ...(withServiceAccount
      ? { [EMAIL_CREATION_FORM_FIELD_NAME_FROM]: { withServiceAccount } }
      : null),
    [EMAIL_CREATION_FORM_FIELD_NAME_TO]: {
      ...recipientsFieldProps,
      loadInitialValue: loadRecipientsInitialValue,
    },
  }
}
